module.exports = __webpack_public_path__ + "static/media/SourceSansPro-Regular.5182da42.ttf";